module.exports = __webpack_public_path__ + "img/joice-kelly-PFN8tB5iGEA-unsplash.f23c94dc.jpg";